import React, { useContext } from 'react';
import { FormikContextType } from 'formik';
import { IProcedure } from 'common/schema/Procedure';
import { ProcedureMachine } from 'common/schema/ProcedureMachine';

export const ProcedureContext = React.createContext({
  procedure: (undefined as any) as IProcedure,
  procedureFormik: (undefined as any) as FormikContextType<IProcedure>
});

// TODO/LOW Gestire quando è `undefined`
export const useProcedureContext = () => {
  const context = useContext(ProcedureContext);
  return {
    ...context,
    getField<T>(name: string) {
      return [
        context.procedureFormik.getFieldProps<T>(name),
        context.procedureFormik.getFieldHelpers<T>(name)
      ] as const;
    },
    disabled: !ProcedureMachine.allows(context.procedure, 'edit')
  };
};
